import { BoxProps, Flex, Text } from '@chakra-ui/react'
import { colors } from '@hb/shared'

export const PostSignOnText = (props: BoxProps) => (
  <Flex
    flexFlow="column"
    px={3}
    pb={5}
    mb={3}
    borderBottom="1px solid"
    borderColor="#cdcdcd"
    {...props}>
    <Text fontFamily="Comfortaa" color={colors.green.hex} fontWeight={600} fontSize="lg">
      Thank you!
    </Text>
    <Flex px={3} flexFlow="column" gap={1}>
      <Text fontSize="md" mb={1}>
        Thank you for confirming you would like to sign on! If you haven't already, please reach out
        to the midwife in order to schedule an appointment.
      </Text>
      <Text mb={1}>
        As always, please don't hesitate to schedule a call with us or reach out via email if you
        have any questions about your assessment.
      </Text>
      <Text>
        As a friendly reminder, the initial retainer is due by your first visit. Accepted payment
        methods are listed at the bottom of your assessment.
      </Text>
    </Flex>
    {/* <Flex pt={2} gap={2} w="100%" flexFlow="column">
      <Flex w="100%" flexFlow={['column', 'row']}>
        <SolidActionButton onClick={onEditSignOn} flex={1} size="sm">
          <EditIcon filter="drop-shadow(1px 1px 3px #00000099)" mr={2} />
          <Text>Sign On Info</Text>
        </SolidActionButton>
      </Flex>
      <ActionButton onClick={onViewPlans} flex={1} size="sm">
        <Text>Your coverage</Text>
      </ActionButton>
      <ContactButtons />
    </Flex> */}
  </Flex>
)
